<template>
  <b-card
    class="collection-card"
    :class="overdueClass"
    :style="{ borderColor: computedStatusData.color }"
  >
    <h4 class="text-center mt-2 mb-3" :style="{ color: computedStatusData.color }">
      {{ computedStatusData.header }}
    </h4>
    <table class="p-3 text-nowrap" style="width: 100%">
      <tr>
        <th><h4>ID Number:</h4></th>
        <td class="text-right"><h4>{{ object.id_number }}</h4></td>
      </tr>
      <tr>
        <th><h4>Arrived Time:</h4></th>
        <td class="text-right"><h4>{{ object.arrived_date | toDateTime }}</h4></td>
      </tr>
      <tr>
        <th><h4>Card Arrived:</h4></th>
        <td class="text-right"><h4>{{ cardArrivedTime | toUpperCaseFirstSentence }}</h4></td>
      </tr>
    </table>
    <div class="text-center mt-4">
      <img :id="`${object.uuid}-barcode`" alt="Barcode" width="200" height="200" src="" />
      <p class="display-4 text-muted mb-0 pt-2">{{ object.barcode }}</p>
      <b-button
        :variant="computedStatusData.variant"
        class="mt-3 mb-2 text-nowrap"
        style="min-width: 50%"
        @click="onStatusButtonClick"
      >
        {{ computedStatusData.text }}
      </b-button>
    </div>
  </b-card>
</template>

<script>
export default {
  name: "CollectionCard",
  props: {
    object: { type: Object, required: true },
    notifyIfOverdue: { type: Boolean, default: false }
  },
  data() {
    return {
      cardArrivedTime: null,
      overdue: false,
      intervalId: null,
      lastNotificationTime: null,
      audio: null,
	    notified: false,
    };
  },
  computed: {
    computedStatusData() {
      if ([0, "0"].includes(this.object.current_status)) {
        return {
          header: "Arrived",
          variant: "outline-secondary",
          text: 'Move to "In Progress"',
          color: this.overdue ? "#dc3545" : "#6c757d",
          nextStatusId: 1,
          nextStatusDateFieldName: "in_progress_on"
        };
      } else if ([1, "1"].includes(this.object.current_status)) {
        return {
          header: "In Progress",
          variant: "outline-warning",
          text: 'Move to "Ready to Handout"',
          color: this.overdue ? "#dc3545" : "#ffc107",
          nextStatusId: 2,
          nextStatusDateFieldName: "ready_to_handout_on"
        };
      } else if ([2, "2"].includes(this.object.current_status)) {
        return {
          header: "Ready to Handout",
          variant: "outline-success",
          text: 'Move to "Completed"',
          color: this.overdue ? "#dc3545" : "#28a745",
          nextStatusId: 3,
          nextStatusDateFieldName: "completed_on"
        };
      } else {
        return {
          header: "Completed",
          variant: "outline-danger",
          text: 'Return to "Ready to Handout"',
          color: this.overdue ? "#dc3545" : "#dc3545",
          nextStatusId: 2,
          nextStatusDateFieldName: "returned_on"
        };
      }
    },
    overdueClass() {
      return this.overdue ? "flash-overdue" : "";
    }
  },
  methods: {
    generateBarCode() {
      const barcodeElement = document.getElementById(`${this.object.uuid}-barcode`);
      if (!barcodeElement) return;
      if (this.object.scraped_barcode_image_url) {
        barcodeElement.src = this.object.scraped_barcode_image_url;
      }
    },
    onStatusButtonClick() {
      const params = {
        ...this.object,
        current_status: this.computedStatusData.nextStatusId,
        [this.computedStatusData.nextStatusDateFieldName]: new Date().toISOString()
      };
      if ([3, "3"].includes(this.object.current_status)) {
        params.completed_on = null;
      }
      this.$emit("onCardUpdate", { uuid: this.object.uuid, data: { ...params } });
    },
    checkIfOverdue() {
      if (!this.object.arrived_date) return;
      if ([3, "3"].includes(this.object.current_status)) {
        this.overdue = false;
        return;
      }
      const createdTime = new Date(this.object.arrived_date).getTime();
      const now = Date.now();
      const diff = now - createdTime;
      this.overdue = diff > 2 * 60 * 1000; // 2 min.
	    this.isFresh = diff < 5 * 60 * 1000; // 5 min.
	    
	    // Notify if overdue, new and not notified yet
	    if (!this.notified && this.overdue && this.isFresh && this.notifyIfOverdue && [0, "0"].includes(this.object.current_status)) {
		    this.notifyAudio();
				this.notified = true;
	    }
    },
	  notifyAudio() {
		  this.audio = new Audio('/static/sounds/notification.mp3');
		  this.audio.preload = "auto";
		  this.audio.volume = 1.0;
		  this.audio.play().catch(() => {});
	  },
  },
  mounted() {
		this.notified = false;
    this.generateBarCode();
    this.cardArrivedTime = this.$options.filters.relativeDate(this.object.arrived_date);
    if (this.notifyIfOverdue) {
      this.notifyAudio();
    }
    this.intervalId = setInterval(() => {
      this.cardArrivedTime = this.$options.filters.relativeDate(this.object.arrived_date);
      this.checkIfOverdue();
    }, 5000);
  },
  beforeDestroy() {
    if (this.intervalId) clearInterval(this.intervalId);
  }
};
</script>

<style lang="scss" scoped>
.collection-card {
  cursor: pointer;
}

.flash-overdue {
  animation: overdueFlash 0.5s infinite alternate;
}

@keyframes overdueFlash {
  0% {
    border: 2px solid red;
  }
  100% {
    border: 2px solid orange;
  }
}
</style>
